class LibertasCartPage extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.addEventListener('click', (event) => this.handleClick(event));
  }

  async handleClick(event) {
    const line = event.target.closest('[data-cart-page-line]');
    if (line) {
      if (event.target.closest('[data-cart-page-remove]')) {
        await this.changeLine(line.dataset.lineKey, 0);
        return;
      }

      const quantityButton = event.target.closest('[data-cart-page-quantity]');
      if (quantityButton) {
        const currentQuantity = Number(line.dataset.quantity);
        const nextQuantity = quantityButton.dataset.cartPageQuantity === 'increase'
          ? currentQuantity + 1
          : Math.max(0, currentQuantity - 1);
        await this.changeLine(line.dataset.lineKey, nextQuantity);
        return;
      }
    }

    const track = this.querySelector('[data-cart-recs-track]');
    if (!track) return;
    if (event.target.closest('[data-cart-recs-prev]')) {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    } else if (event.target.closest('[data-cart-recs-next]')) {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    }
  }

  async changeLine(key, quantity) {
    if (this.classList.contains('is-loading')) return;
    this.setLoading(true);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id: key, quantity }),
      });
      if (!response.ok) throw new Error(await this.getErrorMessage(response));
      await this.refresh();

      const drawer = document.querySelector('[data-cart-drawer]');
      await drawer?.refresh?.();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-page' } }));
    } catch (error) {
      this.showError(error.message);
    } finally {
      this.setLoading(false);
    }
  }

  async refresh() {
    const sectionId = this.dataset.sectionId;
    const response = await fetch(
      `${window.Shopify.routes.root}cart?sections=${encodeURIComponent(sectionId)}`
    );
    if (!response.ok) throw new Error('No se pudo actualizar el carrito.');

    const sections = await response.json();
    const html = sections[sectionId] || Object.values(sections)[0];
    if (!html) throw new Error('No se pudo actualizar el carrito.');

    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const nextPage = parsed.querySelector('[data-cart-page]');
    if (!nextPage) throw new Error('No se pudo actualizar el carrito.');

    this.innerHTML = nextPage.innerHTML;
    const itemCount = nextPage.querySelectorAll('[data-cart-page-line]').length
      ? [...nextPage.querySelectorAll('[data-cart-page-line]')]
        .reduce((total, line) => total + Number(line.dataset.quantity), 0)
      : 0;
    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = String(itemCount);
    });
  }

  setLoading(loading) {
    this.classList.toggle('is-loading', loading);
    this.toggleAttribute('aria-busy', loading);
  }

  showError(message) {
    const error = this.querySelector('[data-cart-page-error]');
    if (!error) return;
    error.textContent = message || 'Ha ocurrido un error. Inténtalo de nuevo.';
    error.hidden = false;
  }

  async getErrorMessage(response) {
    const responseText = await response.text();
    try {
      const payload = JSON.parse(responseText);
      return payload.description || payload.message || 'Ha ocurrido un error. Inténtalo de nuevo.';
    } catch {
      return responseText.trim() || 'Ha ocurrido un error. Inténtalo de nuevo.';
    }
  }
}

if (!customElements.get('libertas-cart-page')) {
  customElements.define('libertas-cart-page', LibertasCartPage);
}
